import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Text, Title } from '../../../components/presentation/Text'
import { useCloseShareForm, useSetShareForm, useShareForm } from './_context/ShareFormContext'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import Button from '../../../components/actions/Button'
import Center from '../../../components/helpers/Center'
import FlexGrid from '../../../components/structure/FlexGrid'
import FormLoader from '../_load/FormLoader'
import Icon from '../../../components/shapes/Icon'
import PlaceTypeSelect from '../../../containers/places/select/PlaceTypeSelect'
import Separator from '../../../components/helpers/Separator'

const SharePrivateForm = () => {
  const [placeType, setPlaceType] = React.useState()
  const { t } = useTranslation('shareForm')
  const onClose = useCloseShareForm()
  const form = useShareForm()
  const navigate = useNavigation()

  const goToPlaces = () => {
    if (!placeType) return false
    const url = `/places/${placeType}?formId=${form.id}&formName=${form.name}`
    navigate(url)
  }

  return (
    <Fragment>
      <Center>
        <Icon name="BsFillEnvelopeFill" size="2rem" />
      </Center>

      <Separator weight={4} />

      <Title size="h4" align="center">
        {form.name}
      </Title>

      <Text align="center">{t('privateSubtitle')}</Text>

      <Separator weight={6} />
      <PlaceTypeSelect value={placeType} onChange={setPlaceType} />
      <Separator weight={6} />

      <FlexGrid gutter={0.5}>
        <Button onClick={onClose} transparent>
          {t('cancel')}
        </Button>
        <Button onClick={goToPlaces} disabled={!placeType}>
          {t('sendForm')}
        </Button>
      </FlexGrid>
    </Fragment>
  )
}

const LoaderWrapper = () => {
  const form = useShareForm()
  const updateForm = useSetShareForm()

  return (
    <FormLoader id={form.id} onLoad={updateForm}>
      <SharePrivateForm />
    </FormLoader>
  )
}

export default LoaderWrapper
